import React from 'react';
import { Clock, MessageSquare, Sparkles, Users } from 'lucide-react';

export default function ConsumerCTA() {
  const benefits = [
    {
      icon: <Clock className="h-10 w-10 text-blue-600" />,
      title: "Save Time Daily",
      text: "Get instant answers without searching through websites or waiting for responses"
    },
    {
      icon: <MessageSquare className="h-10 w-10 text-blue-600" />,
      title: "Natural Conversations",
      text: "Talk to your genie just like you would with a helpful friend"
    },
    {
      icon: <Sparkles className="h-10 w-10 text-blue-600" />,
      title: "Smart & Personalized",
      text: "Your genie learns and adapts to help you better over time"
    },
    {
      icon: <Users className="h-10 w-10 text-blue-600" />,
      title: "Always Available",
      text: "Get help whenever you need it - day or night, no waiting required"
    },
  ];

  return (
    <section className="w-full bg-slate-50 py-16 sm:py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        {/* Main Title & Subtitle */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-gray-900 mb-6">
            Your Life, <br />
            <span className="italic text-blue-600">Simplified</span>
          </h2>
          <p className="mt-4 text-lg sm:text-xl leading-8 text-gray-600 max-w-3xl mx-auto">
            Experience the convenience of having a personal genie that understands your needs and helps you accomplish more every day.
          </p>
        </div>

        {/* Statistics Bar */}
        <div className="mb-12 md:mb-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 max-w-4xl mx-auto">
            <div className="text-center p-6 bg-white rounded-lg shadow-md">
              <div className="text-4xl sm:text-5xl font-bold text-blue-600 mb-2">Instant</div>
              <p className="text-gray-700 font-medium text-base sm:text-lg">Answers & Help</p>
            </div>
            <div className="text-center p-6 bg-white rounded-lg shadow-md">
              <div className="text-4xl sm:text-5xl font-bold text-blue-600 mb-2">Free</div>
              <p className="text-gray-700 font-medium text-base sm:text-lg">To get started</p>
            </div>
            <div className="text-center p-6 bg-white rounded-lg shadow-md">
              <div className="text-4xl sm:text-5xl font-bold text-blue-600 mb-2">Easy</div>
              <p className="text-gray-700 font-medium text-base sm:text-lg">Setup in minutes</p>
            </div>
          </div>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 md:mb-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="flex items-start space-x-4">
              <div className="flex-shrink-0 mt-1">
                {benefit.icon}
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{benefit.title}</h3>
                <p className="text-gray-600 leading-relaxed">{benefit.text}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="text-center">
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 sm:p-12 text-white">
            <h3 className="text-2xl sm:text-3xl font-bold mb-4">
              Ready to Get Started?
            </h3>
            <p className="text-lg sm:text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
              Join thousands of people who are already using genies to make their daily lives easier and more productive.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a
                href="/genie-hub/my-genies"
                className="px-8 py-3 bg-white text-blue-600 font-semibold rounded-lg hover:bg-gray-100 transition text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 duration-300"
              >
                Start For Free
              </a>
              <a
                href="/genie-hub/my-genies"
                className="text-blue-100 hover:text-white font-medium text-lg transition-colors duration-300"
              >
                Browse Genies →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}